<app-background></app-background>

<div class="welcome">
  <h1 class="mat-headline-2 welcome__title">{{ 'anms.welcome.title' | translate }}</h1>

  <div>
    <p class="mat-subtitle-1">{{ 'anms.welcome.text' | translate }}</p>
    <mat-divider></mat-divider>

    <div class="welcome__section">
      <img class="welcome__img" src="/assets/sharex.png" alt="ShareX"/>
      <a mat-button color="primary" class="welcome__link" href="https://youtrack.targem.ru/articles/TG-A-258">
        {{ 'anms.welcome.article_1' | translate}}
      </a>

      <a mat-button color="primary" class="welcome__link" href="https://youtrack.targem.ru/articles/TG-A-112">
        {{ 'anms.welcome.article_2' | translate}}
      </a>
      <a href="/assets/distr/targem_sharex.exe" mat-raised-button color="primary">
        {{ 'anms.welcome.download_dist' | translate }}
        <mat-icon iconPositionEnd>download</mat-icon>
      </a>
    </div>

  </div>

</div>
